export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 1_01.8da1b99c.jpg";